import { create, StateCreator } from 'zustand';
import { persist } from 'zustand/middleware';

import type { CommonStoreState } from '@/types/store.types';

const commonStore: StateCreator<CommonStoreState> = set => ({
  isProcessing: false,
  isFormChanged: false,
  isFormUpdated: false,
  scrollTop: undefined,
  myAccountName: undefined,
  persistState: undefined,
  setIsProcessing: isProcessing => set({ isProcessing }),
  setScrollTop: (scrollTop: () => void) => set({ scrollTop }),
  setIsFormChanged: isFormChanged => set({ isFormChanged }),
  setIsFormUpdated: isFormUpdated => set({ isFormUpdated }),
  setMyAccountName: myAccountName => set({ myAccountName }),
  setPersistState: persistState => set({ persistState }),
});

export const useCommonStore = create(
  persist(commonStore, {
    name: 'common',
    partialize: state =>
      Object.fromEntries(
        Object.entries(state).filter(([key]) =>
          ['myAccountName', 'persistState'].includes(key),
        ),
      ),
  }),
);
